// get mechanic job cards

export const GET_MECHANIC_JOBCARDS_REQUEST = 'GET_MECHANIC_JOBCARDS_REQUEST';
export const GET_MECHANIC_JOBCARDS_SUCCESS = 'GET_MECHANIC_JOBCARDS_SUCCESS';
export const GET_MECHANIC_JOBCARDS_FAIL = 'GET_MECHANIC_JOBCARDS_FAIL';

// get mechanic attendance list

export const GET_MECHANIC_ATTENDANCE_LIST_REQUEST =
  'GET_MECHANIC_ATTENDANCE_LIST_REQUEST';
export const GET_MECHANIC_ATTENDANCE_LIST_SUCCESS =
  'GET_MECHANIC_ATTENDANCE_LIST_SUCCESS';
export const GET_MECHANIC_ATTENDANCE_LIST_FAIL =
  'GET_MECHANIC_ATTENDANCE_LIST_FAIL';

// mechanic clock in

export const CLOCK_IN_REQUEST = 'CLOCK_IN_REQUEST';
export const CLOCK_IN_SUCCESS = 'CLOCK_IN_SUCCESS';
export const CLOCK_IN_FAIL = 'CLOCK_IN_FAIL';
export const CLEAR_CLOCK_IN_STATE = 'CLEAR_CLOCK_IN_STATE';

// mechanic clock out

export const CLOCK_OUT_REQUEST = 'CLOCK_OUT_REQUEST';
export const CLOCK_OUT_SUCCESS = 'CLOCK_OUT_SUCCESS';
export const CLOCK_OUT_FAIL = 'CLOCK_OUT_FAIL';
export const CLEAR_CLOCK_OUT_STATE = 'CLEAR_CLOCK_OUT_STATE';

// mechanic break start

export const BREAK_START_REQUEST = 'BREAK_START_REQUEST';
export const BREAK_START_SUCCESS = 'BREAK_START_SUCCESS';
export const BREAK_START_FAIL = 'BREAK_START_FAIL';
export const CLEAR_BREAK_START_STATE = 'CLEAR_BREAK_START_STATE';

// mechanic break end

export const BREAK_END_REQUEST = 'BREAK_END_REQUEST';
export const BREAK_END_SUCCESS = 'BREAK_END_SUCCESS';
export const BREAK_END_FAIL = 'BREAK_END_FAIL';
export const CLEAR_BREAK_END_STATE = 'CLEAR_BREAK_END_STATE';
